import _ from "underscore";
import $ from "jquery";

import View from "backdraft-app/src/view";

import InputView from "shared/controls/input_view";
import EditableSelectInputView from "shared/controls/editable_select_input_view";
import EditableTextInputView from "shared/controls/editable_text_input_view";

import ActionBarButton from "./action_bar_button";
import bulkActionsTemplate from "./templates/action_bar/bulk_actions.jst";

const ActionBarTextFilter = EditableTextInputView.extend({
  beforeRender() {
    ActionBarTextFilter.__super__.beforeRender.apply(this, arguments);
    this.$el.addClass("filter-area-item");
  }
});

const ActionBarSelectFilter = EditableSelectInputView.extend({
  beforeRender() {
    ActionBarSelectFilter.__super__.beforeRender.apply(this, arguments);
    this.$el.addClass("filter-area-item");
  }
});

export const ActionBarCustomFilter = InputView.extend({
  tagName: "div",

  className: "filter-area-item",

  initialize() {
    ActionBarCustomFilter.__super__.initialize.apply(this, arguments);

    if (!this.options.model) {
      throw new Error("model is required for filter components");
    }
    this.model = this.options.model;
  },

  _initBindings() {

  }
});

const ActionBar = View.extend({
  className: "action-bar",

  template: `
      <div class="filter-area">
      </div>
      <div class="button-area">
      </div>
    `,

  customTemplate: `
      <div class="form-inline filter-area left">
      </div>
      <div class="form-inline button-area right">
      </div>
    `,

  bulkActionsTemplate,

  events: {
    "click .bulk-actions-control li a": "_onBulkActionClick"
  },

  initialize(options) {
    if (!options.model) {
      throw new Error("model is required");
    }
    this.filtersConfig = options.filters || [];
    this.multiSelectFilterConfig = options.multiSelectFilters || [];
    this.buttonsConfig = options.buttons || [];
    this.bulkConfig = options.bulk || {};
    this.customActionBarTargetNode = options.customActionBarTargetNode;
  },

  lock(value) {
    _.each(this.children, (v, k) => {
      v.lock && v.lock(value);
    });
    this.lockBulkSelect(value);
  },

  lockBulkSelect(disabled) {
    // check globally since the controls may have been moved out of the scope of the action table
    $(".bulk-actions-control .dropdown button").prop("disabled", disabled).toggleClass("disabled", disabled);
  },

  render() {
    // If given a custom target DOMNode
    if (this._usesCustomActionBarDOMNode()) {
      this.customActionBarTargetNode().html(this.customTemplate);
      this.customActionBarTargetNode().find(".filter-area").append(_.pluck(this._buildFilters(), "$el"));
      // build / append button views
      this.customActionBarTargetNode().find(".button-area")
        .append(_.pluck(this._buildButtons(), "$el"))
        .append(this._buildBulkActions());
      this.customActionBarTargetNode().find(".bulk-actions-control li a").on("click", this._onBulkActionClick.bind(this));
      return this;
    } else {
      // otherwise render it the normal way
      this.$el.html(this.template);
      // build / append filter views
      const $filterEl = this.$(".filter-area");
      $filterEl.append(_.pluck(this._buildFilters(), "$el"));

      this._appendFilters($filterEl);

      // build / append button views
      this.$(".button-area")
        .append(_.pluck(this._buildButtons(), "$el"))
        .append(this._buildBulkActions());
      return this;
    }
  },

  isEmpty() {
    let containers;
    if (this._usesCustomActionBarDOMNode()) {
      this.customActionBarTargetNode();
      containers = this.customActionBarTargetNode().find('.filter-area, .button-area');
    } else {
      containers = this.$('.filter-area, .button-area');
    }
    return containers.children().length === 0 && containers.text().trim() === '';
  },

  _usesCustomActionBarDOMNode() {
    return this.customActionBarTargetNode && this.customActionBarTargetNode().length > 0;
  },

  _filterClass(type) {
    if (type === "text") {
      return ActionBarTextFilter;
    } else if (type === "select") {
      return ActionBarSelectFilter;
    } else if (type === "custom") {
      return ActionBarCustomFilter;
    } else {
      throw new Error(`Invalid filter type ${type}`);
    }
  },

  _appendFilters($filterEl) {

  },

  _buildFilters() {
    let Klass;
    let view;
    const filters = _.map(this.filtersConfig, function(config) {
      if (config.present && !config.present()) {
        return null;
      }
      Klass = this._filterClass(config.type);
      view = new Klass(_.extend({ model: this.model }, config)).render();
      this.child(`filter-${view.cid}`, view);
      return view;
    }, this);
    return _.compact(filters);
  },

  _buildButtons() {
    let view;
    const buttons = _.map(this.buttonsConfig, function(config) {
      if (config.present && !config.present()) {
        return null;
      }
      view = new ActionBarButton(config).render();
      this.child(`button-${view.cid}`, view);
      return view;
    }, this);
    return _.compact(buttons);
  },

  _buildBulkActions() {
    if (this.bulkConfig.present && !this.bulkConfig.present()) {
      return "";
    }
    const actions = this.bulkConfig.actions;
    const visibleActions = _.select(actions, config => !config.present || config.present());

    if (!_.isEmpty(visibleActions)) {
      return this.bulkActionsTemplate({ actions: visibleActions });
    } else {
      return "";
    }
  },

  _onBulkActionClick(event) {
    const actionName = $(event.target).data("action-name");
    const config = _.find(this.bulkConfig.actions, config => _.result(config, "text") === actionName);
    if (!config) {
      throw new Error(`could not find bulk action with name ${actionName}`);
    }
    this.trigger("bulk-action-selected", config, this.bulkConfig.click || $.noop);
    // don't stop propogation as we want the dropdown to close
    event.preventDefault();
  }
});

export default ActionBar;
